import { computed, thunk, action, persist } from 'easy-peasy';
import callApi from '../helpers/ApiAction';

const state = {
  loggedIn: false,
  currentUser: null,
  tokens: {
    access_token: null,
    refresh_token: null
  }
};

const selectors = {
  isLoggedIn: computed(
    state => state.loggedIn && state.tokens.access_token && state.currentUser
  ),
  authToken: computed(state => state.tokens.access_token)
};

const actions = {
  doLogin: thunk(async (actions, payload) => {
    const res = await callApi({
      endpoint: 'login',
      method: 'POST',
      body: payload,
      callbacks: payload?.callbacks
    });

    const { access_token, refresh_token } = await res.json();

    actions.setAuthentication({
      access_token,
      refresh_token
    });

    actions.getUser();
  }),
  getUser: thunk(async (actions, payload) => {
    const res = await callApi({
      endpoint: 'user',
      method: 'GET'
    });

    const json = await res.json();

    actions.setUser(json);
  }),
  doLogout: action(state => {
    state.loggedIn = false;
    state.tokens = {
      access_token: null,
      refresh_token: null
    };
  }),
  setAuthentication: action((state, payload) => {
    if (payload.access_token) {
      state.tokens = payload;
      state.loggedIn = true;
    }
  }),
  setUser: action((state, payload) => {
    state.currentUser = payload;
  })
};

export default persist({
  ...state,
  ...selectors,
  ...actions
});
